import urlRegex from './urlRegex';
import mailRegex from './mailRegex';

export const fieldRegex = /\s*{[^}]+}\s*/g;

export function prependHttp(url: string, { https = true } = {}): string {
  if (typeof url !== 'string') {
    throw new TypeError(`Expected \`url\` to be of type \`string\`, got \`${typeof url}\``);
  }

  url = url.trim();

  if (/^\.*\/|^(?!localhost)\w+?:/.test(url)) {
    return url;
  }

  return url.replace(/^(?!(?:\w+?:)?\/\/)/, https ? 'https://' : 'http://');
}

export default {
  isUrl(text: string) {
    const field = text.match(fieldRegex);
    if (typeof field !== 'undefined' && field !== null) {
      return true;
    }
    return urlRegex({ allowSpacing: true }).test(text);
  },

  isMail(text: string) {
    return mailRegex().test(text);
  },

  normaliseMail(email: string) {
    if (email.toLowerCase().startsWith('mailto:')) {
      return email;
    }
    return `mailto:${email}`;
  },

  normalizeUrl(url: string) {
    const nurl = url.trim();

    if (nurl.startsWith('{')) {
      return nurl;
    }

    return prependHttp(nurl);
  },
};
